import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
@Component({
  standalone: true,
  selector: 'app-non-renewal-notice',
  templateUrl: './non-renewal-notice.component.html',
  imports: [CommonModule, TranslatePipe],
  styleUrls: ['./non-renewal-notice.component.css'],
})
export class NonRenewalNoticeComponent implements OnInit, OnDestroy {
  @Input() useDelay = false;
  isAcmic: boolean;
  destroy$ = new Subject<void>();
  nonRenewalPolicies: any[] = [];

  constructor(private policyDataService: PolicyDataService, private acmicService: AcmicService,) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit(): void {
    this.getPolicy();
  }

  getPolicy(): void {
    this.policyDataService.$rawPolicies
      .pipe(takeUntil(this.destroy$))
      .subscribe(policies => {
        this.nonRenewalPolicies = Array.isArray(policies)
          ? policies.filter(policy => policy?.showNonRenewalNotice === true)
          : [];
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}